<template>
  <div class="drawer box-transition" :style="drawerWidth">
    <div class="drawer-box">
      <slot />
    </div>
    <a class="drawer-button bg-theme text-white"
      v-if="showTrigger"
      @click.prevent="trigger">
      <Icon :type="show ? 'ios-arrow-back' : 'ios-arrow-forward'" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    width: {
      type: Number,
      default: 400
    },
    showTrigger: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: this.value
    }
  },
  computed: {
    drawerWidth () {
      return {
        width: this.show ? this.width + 'px' : 0,
        margin: this.show ? '20px 0 20px 20px' : '20px 0'
      }
    }
  },
  methods: {
    trigger () {
      this.show = !this.show
      this.$emit('input', this.show)
      this.$emit('on-trigger', this.show)
    }
  }
}
</script>

<style lang="less" scoped>
.drawer {
  height: calc(100vh - 40px);
  border-radius: 8px;
  background: #ffffff;

  &-box {
    position: relative;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &-button {
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    right: -60px;
    bottom: 10px;
    border-radius: 50%;
    line-height: 25px;
    text-align: center;
    font-size: 20px;
    font-weight: bolder;
    color: #ffffff;
  }
}
</style>

